import script from "./ServiceEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceEditView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceEditView.vue?vue&type=style&index=0&id=89bd10cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89bd10cc"]])

export default __exports__